import styled from 'styled-components'
import { Button } from '@material-ui/core'
import ArrowDropDown from '@material-ui/icons/ArrowDropDown'

export const postersPageStyle = {
  marginTop: '2rem',
  padding: '1rem',
  paddingLeft: 'calc(50% - 30vw)'
}

export const PostersControls = styled.div`
    margin-top: 2rem;
  `

export const CountryButton = styled(Button)`
    && {
      color: inherit;
      font: inherit;
      display: inline;
      margin: -0.2rem 0rem 0rem;
      padding: 0 0.4rem;
      line-height: inherit;
      text-transform: capitalize;
    }
  `

export const CenteredArrow = styled(ArrowDropDown)`
    && {
      vertical-align: middle;
    }
  `
